import { tenantIDAtom } from "atoms/GlobalAtoms";
import { useAtomValue } from "jotai";

import { Button } from "reactstrap";
import AppSpinner from "../../../elements/AppSpinner";
import { useNavigate } from "react-router-dom";

const QuickNoteSaving = ({
  page,
  recordID,
  closeModal,
  action = "Quick Note",
}) => {
  const navigate = useNavigate();
  const tenantID = useAtomValue(tenantIDAtom);
  const quickNoteSaving = page.includes("quick-note");

  if ((quickNoteSaving && !recordID) || !quickNoteSaving) {
    return (
      <div className="d-flex flex-column align-items-center p-4">
        <div className="mb-4 text-center" style={{ width: 200 }}>
          {quickNoteSaving
            ? "Loading Your Recording and Transcription"
            : `Processing your audio`}
        </div>
        <AppSpinner
          style={{ height: 170, width: 170, fontSize: 80 }}
          className="mb-5"
        />
      </div>
    );
  }

  return (
    <div className="d-flex flex-column align-items-center p-4">
      <div className="text-center font-weight-500">
        Successfully saved {action}!
      </div>
      <div
        style={{
          border: "20px solid var(--primary)",
          borderRadius: "50%",
          width: 170,
          height: 170,
        }}
        className="mt-3 mb-4 d-flex justify-content-center align-items-center"
      >
        <i className="mdi mdi-check text-primary" style={{ fontSize: 100 }} />
      </div>
      <Button
        size="sm"
        color="primary"
        onClick={() => {
          navigate(
            `/clouds/${tenantID}/records/Activities/details/${recordID}/Summary`
          );
          closeModal();
        }}
      >
        View Quick Note
      </Button>
    </div>
  );
};

export default QuickNoteSaving;
